/* eslint-disable no-console */

export const createLogger = prefix => {
  return {
    info: (...args) => console.info(prefix, ...args),
    warn: (...args) => console.warn(prefix, ...args),
    error: (...args) => console.error(prefix, ...args),
    debug: (...args) => console.debug(prefix, ...args)
  };
};

export const shrinkURL = s => (s?.length > 60 ? `${s.slice(0, 50)}...${s.slice(-7)}` : s);
